import moment from "moment";
import "moment/locale/it";

export default function(){
    if (arguments.length === 0){
        return new Date(0).getTime();
    }
    let value, dim, date;
    let args = [...arguments];
    if (moment.isDate(arguments[0])){
        date = moment(arguments[0]);
        args = args.slice(1);
    } else if (typeof arguments[0] === "string"){
        date = moment(arguments[0], arguments[1], true);
        args = args.slice(2);
    } else {
        date = moment();
    }
    if (!date.isValid){
        return 0;
    }
    value = args[0];
    if (value == null){
        return date.toDate().getTime();
    }
    dim = args[1];
    if (!dim){
        dim = "days";
    }
    date = date.add(value, dim);
    if (!date.isValid()){
        return 0;
    }
    return date.toDate().getTime();
}
